
import React from "react";
import Btn from "../common/Btn";
import { MERCH } from "../../data";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import ProductCard from "../common/ProductCard";
import styles from "../../assets/style.module.css";
import { ITeamWebsite } from "../../../../../services";
import ScrollTrack, { ScrollButtons, useScroller } from "../common/ScrollTrack";

export interface CollectionSliderProps {
    basePath: string;
    website: ITeamWebsite;
}

function CollectionSlider({ website, basePath }: CollectionSliderProps) {

    const labels = i18nManager.Labels;
    const scroller = useScroller();

    return (<section className={styles["collection"]}>
        <div className={styles["collection-grid"]}>
            <div className={styles["collection-aside"]}>
                <span className={styles["subtitle"]}>{website.team.name}</span>
                <h2 className={styles["h1"]}>{labels.home.newest_items}</h2>
                <p className={styles["lead"]}>{labels.home.store_text.replace(":name", website.team.name)}</p>
                <Btn variant="outline" to={pagePath(basePath, "MERCH")}>{labels.view_all}</Btn>
            </div>
            <div className={styles["collection-slider"]}>
                <ScrollTrack trackRef={scroller.ref} className={styles["track-products"]}>
                    {MERCH.map((item) => (<ProductCard key={item.id} item={item} />))}
                </ScrollTrack>
                <div className={styles["collection-btns"]}><ScrollButtons onPrev={scroller.prev} onNext={scroller.next} /></div>
            </div>
        </div>
    </section>);
}

export default CollectionSlider;
